import PropTypes from 'prop-types';
import { createContext, useContext, useState, useMemo } from 'react';


const sessionContext = createContext({
    session: "1,2,3",
    setSession: () => { }
});

export const SessionProvider = ({ children }) => {
    const [session, setSession] = useState("1,2,3");

    const value = useMemo(() => ({ session, setSession }), [session]);

    return (
        <sessionContext.Provider value={value}>
            {children}
        </sessionContext.Provider>
    );
}

SessionProvider.propTypes = {
    children: PropTypes.node.isRequired,
}

export default sessionContext;


export const useSession = () => {
    return useContext(sessionContext);
}
